import React from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import I18n from '../../../resources/i18n/I18n'

const ModalDeactivateUser = ({ showModal, toggleModal, onConfirm }) => {
  const handleConfirm = () => {
    onConfirm()
    toggleModal()
    setTimeout(() => {
      window.location.reload()
    }, 500)
  }

  return (
    <Modal show={showModal} onHide={toggleModal}>
      <Modal.Header closeButton>
        <Modal.Title>{I18n.t('DesactivationTitle')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{I18n.t('DesactivationConfirmMessage')}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-back" onClick={toggleModal}>
          {I18n.t('Cancel')}
        </Button>
        <Button className="primary" onClick={handleConfirm}>
          {I18n.t('Validate')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
export default ModalDeactivateUser
